// extracted by mini-css-extract-plugin
module.exports = {"message":"f-eca","header":"-ah20","text":"HkxRO","icon":"ydUsz"};